import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  finalPayment,
  FinalPaymentUsingToken,
  GetPaymentToken,
  GetStates,
  postIframedata,
  SameAsPatient,
  GetSavedCards,
  InsertPPLogs,
} from "../../../api";
import { ArrowBack, CountertopsOutlined } from "@mui/icons-material";
import {
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText,
  Typography,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  ThemeProvider,
  createTheme,
  TextField,
  Grid,
  Box,
  FormControl,
  InputLabel,
} from "@mui/material";
import { makeStyles, Theme } from "@material-ui/core";
import useMediaQuery from "@mui/material/useMediaQuery";
import useStyles from "../../../css/styles";
import { CreditCardPaymentModel, State } from "../../../store";

// Update log
// FB  8099   01/17/2024  SK   Add Support to Patient Portal to Facilitate Patients Seeing their Invoices and Optionally being able to Pay
// FB  8973   07/02/2024  DK  Guest login enhancements

const PopUpStyles = makeStyles((theme: Theme) => ({
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0,0,30,0.4)",
  },
}));
const theme = createTheme({
  palette: {
    primary: {
      main: "#083A4D",
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        onClick: (e) => e.stopPropagation(),
        BackdropProps: {
          sx: {
            pointerEvents: "none",
          },
        },
      },
    },
  },
});

//FB 8973
export default function GuestPayment(props: any) {
  const matches = useMediaQuery("(min-width:600px)");
  const classes = PopUpStyles();
  const [viewIframe, setViewIframe] = useState(true);
  const [model, setModel] = useState(false);
  const [saveCardModel, setSaveCardModel] = useState(false);
  const JSAlert = require("js-alert");
  const styles = useStyles();
  type CardProps = {
    T_CC_NAME_N: number;
    PATIENT_N: string;
    PAYMENT_N: string;
    CARD_NAME: string;
    PAYMENT_TOKEN: string;
  };
  const styletwo = {
    container: {
      border: "1px grey",
      paddingLeft: matches == false ? "16px" : "80px",
      paddingTop: "40px",
      paddingBottom: "40px",
    },
  };
  const stylestart = {
    container: {
      border: "1px grey",
      paddingLeft: matches == false ? "0px" : "55px",

      paddingTop: "10px",
      backgroundColor: "#F8F8F8",
    },
  };
  const [CardArray, setCardArray] = useState<Array<CardProps>>([
    {
      T_CC_NAME_N: 0,
      PATIENT_N: "",
      PAYMENT_N: "",
      CARD_NAME: "",
      PAYMENT_TOKEN: "",
    },
  ]);
  const [PaymentUrl, setPaymentUrl] = useState("");
  const [sessionId, setSessionId] = useState("");

  const [paymentToken, setPaymentToken] = useState("");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [card, setCardOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [displayName, setDisplayName] = useState("");

  const [amount, setAmount] = useState("");
  const [emrId, setEmrId] = useState(0);
  const [patientID, setPatientID] = useState(0);

  const [paymentButton, setPaymentButton] = useState(true);
  const [patientCC, setPatientCC] = useState({} as CreditCardPaymentModel);
  const [transID, setTransID] = useState();

  const handleInputChange = (e: any) => {
    if (e.target.name == "PaymentAmount") {
      if (e.target.value > 9999.99) {
        return false;
      }
      let match = /(\d{0,4})[^.]*((?:\.\d{0,2})?)/g.exec(
        e.target.value.replace(/[^\d.]/g, "")
      );
      if (
        match != null &&
        e.target.value > 0 &&
        e.target.value != "" &&
        e.target.value <= 9999.99
      ) {
        setPatientCC({ ...patientCC, ["PaymentAmount"]: match[1] + match[2] });
        setPaymentButton(false);
      } else {
        setPatientCC({ ...patientCC, ["PaymentAmount"]: e.target.value });
        setPaymentButton(true);
      }
    }
    if (e.target.name === "phone") {
      if (e.target.value.length > 10) {
        return;
      }
      const digitsOnly = e.target.value.replace(/\D/g, '');
      setPatientCC({ ...patientCC, ["phone"]: digitsOnly });
    } else {
      setPatientCC({ ...patientCC, [e.target.name]: e.target.value });
    }
  };

  function validation() {
    const re = /^[0-9]{5}\-[0-9]{4}$/;
    const rea = /^[0-9]{5}$/;
    const reb = /^[0-9]{9}$/;
    const reexp = /^[a-zA-Z\s]*$/;
    const remonth = /^(0[1-9]|1[012])$/;
    const reyear = /^(?!00)[0-9]{2}$/;

    if (remonth.test(patientCC.month) == false) {
      JSAlert.alert(
        "Please enter 2 digits for month.",
        null,
        JSAlert.Icons.Warning
      );
    } else if (reyear.test(patientCC.year) == false) {
      JSAlert.alert(
        "Please enter 2 digits for year",
        null,
        JSAlert.Icons.Warning
      );
    }
    else if (patientCC.CNP == "null " || patientCC.CNP?.length < 3 || patientCC.CNP?.length > 4) {
      JSAlert.alert(
        "Please enter 3-4 digits CVC number.",
        null,
        JSAlert.Icons.Warning
      );
    }
    else if (
      patientCC.firstNameOnCard == null ||
      patientCC.firstNameOnCard == undefined ||
      patientCC.firstNameOnCard == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid First Name.",
        null,
        JSAlert.Icons.Warning
      );
    }
    else if (
      patientCC.address == null ||
      patientCC.address == undefined ||
      patientCC.address == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid Address.",
        null,
        JSAlert.Icons.Warning
      );
    }
    else if (
      patientCC.city == null ||
      patientCC.city == undefined ||
      patientCC.city == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid City.",
        null,
        JSAlert.Icons.Warning
      );
    }
    else if (
      patientCC.state == null ||
      patientCC.state == undefined ||
      patientCC.state == ""
    ) {
      JSAlert.alert(
        "Please Choose State.",
        null,
        JSAlert.Icons.Warning
      );
    }

    else if (
      patientCC.phone == null ||
      patientCC.phone == undefined ||
      patientCC.phone == "" ||
      patientCC.phone.length == 0 ||
      patientCC.phone.length < 10
    ) {
      JSAlert.alert(
        "Please Enter Valid Cell Phone Number (must contain 10 numerics)",
        null,
        JSAlert.Icons.Warning
      );
    } else {
      let isValidZip = re.test(patientCC.zip)
        ? true
        : reb.test(patientCC.zip)
          ? true
          : rea.test(patientCC.zip)
            ? true
            : false;
      if (isValidZip === false) {
        JSAlert.alert(
          "Zip code must be 5 or 9 digits or xxxxx-yyyyy",
          null,
          JSAlert.Icons.Warning
        );
      } else {
        setOpen(true);
      }
    }
  }
  const handleClickOpen = (e: any) => {
    if (saveCardModel == true) {
      if (
        patientCC.CARD_NAME == null ||
        patientCC.CARD_NAME == undefined ||
        patientCC.CARD_NAME == ""
      ) {
        JSAlert.alert("Please enter Card Name", null, JSAlert.Icons.Warning);
      } else validation();
    } else validation();
  };
  const handleUseCardOpen = (event: ChangeEvent<HTMLInputElement>) => {
    setCardOpen(true);
    setChecked(event.target.checked);
    setViewIframe(false);
  };
  const handleClose = () => {
    setOpen(false);
    setCardOpen(false);
    setChecked(false);
    setViewIframe(true);
    setIframe({
      index: iframe.index + 1,
    });
    setPaymentUrl("");
    setIsDisabled(true);
    setSessionId("");
    setPaymentToken("");
    handleIframeDetails();
  };
  const [isDisabled, setIsDisabled] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const handlePayment = async (event: any) => {
    setShowSpinner(true);
    const re = /^[0-9]\d{0,3}(?:\.\d{1,2})?$/g;
    if (checked == true) {
      setCardOpen(false);
      if (re.test(patientCC.PaymentAmount) == true) {
        setOpen(false);
        let result = await FinalPaymentUsingToken(
          patientCC.PaymentToken,
          patientCC.PaymentAmount,
          0,
          patientID
        );
        if (
          (result.PmtResult.CalliPayTransactionID != null ||
            result.PmtResult.CalliPayTransactionID != "") &&
          result.PmtResult.Status == 1
        ) {
          setTransID(result.PmtResult.CalliPayTransactionID);
          setOpenAlert(true);
        } else if (
          result.PmtResult.ErrorMessage != "" ||
          result.PmtResult.ErrorMessage != null
        ) {
          JSAlert.alert(result.ErrorMessage, null, JSAlert.Icons.Failed);
          navigate("/user/home/Billing");
        }
      } else {
        JSAlert.alert(
          "Please Enter Valid Details",
          null,
          JSAlert.Icons.Warning
        );
        navigate("/user/home/Billing");
      }
    } else {
      if (re.test(patientCC.PaymentAmount) == true) {
        setOpen(false);
        patientCC.PaymentToken = paymentToken;
        patientCC.ExpirationDate = patientCC.month + patientCC.year;
        patientCC.Patient_N = patientID;
        patientCC.IS_PORTAL_PAYMENT = 1;
        let result = await finalPayment(patientCC);
        if (
          (result.PmtResult.CalliPayTransactionID != null ||
            result.PmtResult.CalliPayTransactionID != "") &&
          result.PmtResult.Status == 1
        ) {
          setTransID(result.PmtResult.CalliPayTransactionID);
          setOpenAlert(true);
        } else if (
          result.PmtResult.ErrorMessage != "" ||
          result.PmtResult.ErrorMessage != null
        ) {
          JSAlert.alert(
            result.PmtResult.ErrorMessage,
            null,
            JSAlert.Icons.Failed
          );
          navigate("/user/guestPayment");
        }
      } else {
        JSAlert.alert(
          "Please Enter Valid Details",
          null,
          JSAlert.Icons.Warning
        );
        navigate("/user/home/Billing");
      }
    }
    setShowSpinner(false);
  };

  async function handleIframeDetails() {
    let p_id: any | null = Number(sessionStorage.getItem("PatientInfo"));
    if (Number(p_id) > 0) {
      setPatientID(p_id);
    }
    setShowSpinner(true);
    var data = await postIframedata();
    if (data != null) {
      setPaymentUrl(data.PaymentURL);
      setSessionId(data.SessionID);
      setTimeout(() => {
        setShowSpinner(false);
      }, 5000);
    } else {
      window.location.reload();
    }
    let valueFromSessionStorage = sessionStorage.getItem("PayingAmount");
    if (valueFromSessionStorage) {
      let numberValue = parseFloat(valueFromSessionStorage);
      setPatientCC({ ...patientCC, ["PaymentAmount"]: numberValue });
      setPaymentButton(false);
    }
    let totalFromSessionStorage = sessionStorage.getItem("Total");
    if (totalFromSessionStorage) {
      setTotal(totalFromSessionStorage);
    }
  }


  const [iframe, setIframe] = useState({ index: 0 });

  async function handleChangeCard() {
    setIframe({
      index: iframe.index + 1,
    });
    setPaymentUrl("");
    setIsDisabled(true);
    setSessionId("");
    setPaymentToken("");
    handleIframeDetails();
  }



  const [states, setStates] = useState<State[]>();
  async function getStates() {
    var data = await GetStates();
    setStates(data);
  }


  useEffect(() => {
    handleIframeDetails();
    getStates();
  }, []);
  const Redirect = () => {
    window.location.reload();
  };
  const [ReloadPopUp, setReloadPopup] = useState(false);

  async function iframeVerification() {
    if (paymentToken == "") {
      if (sessionId != "") {
        if (paymentToken == "") {
          var data = await GetPaymentToken(sessionId);
          if (data != null) {
            setPaymentToken(data);
            setIsDisabled(false);
          }
        }
      }
    }
  }

  const [value, setValue] = useState("");
  const [total, setTotal] = useState("");

  const [openAlert, setOpenAlert] = useState(false);
  const handleCloseAlert = () => {
    setOpenAlert(false);
    navigate("/ThankYou");
  };

  function printreceipt() {
    setOpenAlert(false);
    let transaction = { transID: transID, amount: patientCC.PaymentAmount };
    sessionStorage.setItem(
      "Transaction",
      JSON.stringify({ transID: transID, amount: patientCC.PaymentAmount })
    );
    window.open("/payment/printReceipt");
    navigate("/user/home/Billing");
    InsertPPLogs(
      "Clicked on Print Receipt",
      window.location.href,
      "Guest Login",
      ""
    );
  }

  return (
    <div>
      <div className="card" style={stylestart.container}>
        <ListItem>
          <ListItemIcon>
            {/* FB 8973 */}
            <IconButton onClick={() => navigate("/user/guestBilling")}>
              <ArrowBack />
            </IconButton>
          </ListItemIcon>
          <ListItemText>
            <Typography variant="h5">
              <b>Make Payment</b>
            </Typography>
          </ListItemText>
        </ListItem>
      </div>
      <div className="card" style={styletwo.container}>
        <div className="row">
          <div className="col-sm-4">
            <a style={{ textAlign: "left" }}>
              Enter Credit Card Details
              <br />
              {viewIframe && (
                <iframe
                  src={PaymentUrl}
                  key={iframe.index}
                  style={{ height: "70px" }}
                  id="iframe"
                  onLoad={iframeVerification}
                />
              )}
            </a>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "left" }}>
          <a
            className="btn"
            style={{ backgroundColor: "#13607C", color: "white" }}
            onClick={handleChangeCard}
          >
            Change Card Number
          </a>
          <br />
        </div>
        <div className="row">
          <div
            className="col-sm-4"
            style={{ paddingBottom: matches == false ? "20px" : "0px" }}
          >
            {matches && <br />}
            {saveCardModel && (
              <TextField
                name="CARD_NAME"
                disabled={isDisabled}
                placeholder="Card Name*"
                onChange={handleInputChange}
                value={patientCC.CARD_NAME}
                label="CARD_NAME"
                id="outlined-size-small"
                size="small"
                style={{
                  backgroundColor: isDisabled == false ? "none" : "lightgrey",
                }}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <p style={{ textAlign: "left" }}>
              *Expiration Date{" "}
              <input
                type="text"
                style={text.container}
                maxLength={2}
                disabled={isDisabled}
                size={2}
                name="month"
                placeholder="MM"
                value={patientCC.month}
                onChange={handleInputChange}
              ></input>
              &nbsp;
              <input
                type="text"
                style={text.container}
                maxLength={2}
                disabled={isDisabled}
                size={2}
                name="year"
                placeholder="YY"
                value={patientCC.year}
                onChange={handleInputChange}
              ></input>
            </p>
          </div>

          <div className="col-sm-4">
            <p style={{ textAlign: "left" }}>
              *CVC{" "}
              <input
                type="text"
                name="CNP"
                style={text.container}
                size={20}
                maxLength={4}
                disabled={isDisabled}
                value={patientCC.CNP}
                onChange={handleInputChange}
              ></input>
            </p>
          </div>
        </div>
        <Grid container spacing={2} style={{ paddingBottom: "20px" }}>
          <Grid item xs={6}>
            <TextField
              label="*First Name"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="firstNameOnCard"
              value={patientCC.firstNameOnCard}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Last Name"
              name="lastNameOnCard"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              value={patientCC.lastNameOnCard}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*Address"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="address"
              value={patientCC.address}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Address2"
              name="address2"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              InputLabelProps={{ shrink: true }}
              value={patientCC.address2}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="*City"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="city"
              value={patientCC.city}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
              size="small"
            >
              <InputLabel id="demo-simple-select-label">*State</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="state"
                label="State"
                value={patientCC.state}
                onChange={handleInputChange}
                disabled={isDisabled}
              >
                {states?.map((state: State) => (
                  <MenuItem value={state.StateShortName}>
                    {state.StateShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*Zip Code"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="zip"
              InputLabelProps={{ shrink: true }}
              value={patientCC.zip}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Email"
              name="email"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              InputLabelProps={{ shrink: true }}
              value={patientCC.email}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*CellPhone"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="phone"
              value={patientCC.phone}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
        </Grid>
        <Box style={{ paddingLeft: matches == false ? "30%" : "45%" }}>
          <button
            className="btn"
            style={{
              backgroundColor: "#13607C",
              color: "white",
            }}
            onClick={handleClickOpen}
            disabled={isDisabled}
          >
            Next
          </button>
          &nbsp;
          <button
            className="btn"
            style={{
              color: "#13607C",
              backgroundColor: "#F5F5F7",

              borderColor: "#13607C",
            }}
            onClick={() => navigate("/user/home/Billing")}
          >
            Cancel
          </button>
        </Box>
      </div>
      <div className="col-sm-12">
        <Dialog open={open} onClose={handleClose}>
          <DialogContent>
            <label>Total Balance :&nbsp;${total}</label>
            <hr></hr>
            <label>Enter Payment Amount</label>
            <br></br>
            <TextField
              label="*Payment Amount"
              name="PaymentAmount"
              id="outlined-size-small"
              size="small"
              fullWidth
              style={{ marginTop: "20px" }}
              onChange={handleInputChange}
              value={patientCC.PaymentAmount}
              autoComplete="off"
            />
            {matches && <br></br>}
            <button
              className="btn"
              style={{
                backgroundColor: "#13607C",
                color: "white",
                marginTop: "10px",
                marginLeft: "15%",
                width: "75px",
              }}
              onClick={handlePayment}
              disabled={paymentButton}
            >
              Pay
            </button>
            &nbsp;&nbsp;&nbsp;
            <button
              className="btn"
              style={button.container}
              onClick={handleClose}
            >
              Cancel
            </button>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>

      <Dialog
        open={ReloadPopUp}
        style={{
          backdropFilter: "blur(3px)",
        }}
        onClose={Redirect}
      >
        <DialogContent style={{ height: "auto" }}>
          <h5 style={{ textAlign: "center" }}>
            Please refresh this page to make payment!
          </h5>
          <br></br>
          <Box textAlign="center">
            <Button
              variant="contained"
              style={{
                backgroundColor: "#13607C",
                color: "white",
              }}
              onClick={Redirect}
            >
              Ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle id="alert-dialog-title">{"Payment"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: "black" }}
          >
            Payment Successful!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={printreceipt}
            autoFocus
          >
            Print Receipt
          </Button>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleCloseAlert}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <ThemeProvider theme={theme}>
        <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "#083A4D" }} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </div>
  );
}

const button = {
  container: {
    marginTop: "10px",
    width: "75px",
    color: "#13607C",
    backgroundColor: "#F5F5F7",
    borderColor: "#13607C",
  },
};

const text = {
  container: {
    height: "35px",
  },
};

const select1 = {
  container: {
    height: "35px",
    width: "595px",
    borderRadius: "1px",
  },
};

const cards = {
  container: {},
};
